import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {ImpressaoService} from "../../services/impressao.service";
import {NgForm} from "@angular/forms";
import {EnumTamanhoPapel} from "../../../../server/lib/emun/EnumTamanhoPapel";
import {EnumMomentoImprimirAuto} from "../../../../server/lib/emun/EnumMomentoImprimirAuto";
import {DeviceDetectorService} from "ngx-device-detector";
import {ServidorImpressaoService} from "../../services/servidor-impressao.service";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {ModalConfirmacaoComponent} from "../cad-horariosfuncionamento/modal-confirmacao.component";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {ProcessadorReciboTexto} from "../../services/impressao/ProcessadorReciboTexto";

@Component({
  selector: 'app-config-impressao',
  templateUrl: './config-impressao.component.html',
  styleUrls: ['./config-impressao.component.scss']
})
export class ConfigImpressaoComponent implements OnInit {
  private _empresa: any;
  impressoras: any[] = [];
  conectando = true;
  qzInstalado: boolean;
  salvando: boolean;
  layouts = ['PedidoCompleto', 'PedidoResumido', 'UmPorProduto', 'Personalizado'];
  @ViewChild('frmConfigImpressao')   frmConfigImpressao: NgForm;
  mensagemSucesso: string;
  erro: string;
  listaTamanhosPapeis = [
    { valor: EnumTamanhoPapel.Layout80mm, label: '80 mm (48 colunas)' },
    { valor: EnumTamanhoPapel.Layout80mm42car, label: '80 mm (42 colunas)' },
    { valor: EnumTamanhoPapel.Layout58mm, label: '58 mm (35 colunas)' },
    { valor: EnumTamanhoPapel.Layout58mm32car, label: '58 mm (32 colunas)' },
    { valor: EnumTamanhoPapel.LayoutA4, label: 'A4 (modo gráfico)' }
  ];
  recarregar: boolean
  isMobile: boolean;
  @Input()
  possuiModuloFiscal;

  impressoraSelecionada: any = null;
  indexSelecionado: number = -1;
  impressorasAlteradas: boolean = false;

  // Novas propriedades para servidores de impressão
  servidoresImpressao: any[] = [];
  servidorSelecionado: any = null;
  editandoServidor  = false;
  configurandoLocal  = false;
  modalServidorAberto = false;
  temServidorImpressao  = false;

  // Novas propriedades para fluxo de servidor-impressora
  modoCriacaoRapidaServidor: boolean = false;

  // Novas propriedades para seleção de impressoras
  impressorasDisponiveis: any[] = [];
  impressorasSelecionadas: any[] = [];
  detalhesImpressoras: any = {};
  carregandoDetalhes = false;
  msgErro: string;

  // Dialog layout personalizado
  dialogLayoutAberto = false;
  opcoesLayoutTemp: any = null;
  opcoesLayoutTempAlterado = false;

  previewCarregando = false;
  previewUrl: string | null = null;
  previewUrlSafe: SafeResourceUrl | null = null;
  previewTextoSecoes: any[] = [];
  previewImpressoraCarregando = false;
  previewImpressoraUrl: string | null = null;
  previewImpressoraUrlSafe: SafeResourceUrl | null = null;
  previewImpressoraTextoSecoes: any[] = [];
  tamanhosFonteLayoutHtml = [
    { valor: 'normal', label: 'Normal' },
    { valor: 'pequena', label: 'Pequena' },
    { valor: 'grande', label: 'Grande' }
  ];
  tamanhosFonteLayoutTexto = [
    { valor: 'normal', label: 'Normal (Fonte A)' },
    { valor: 'pequena', label: 'Menor (Fonte B)' },
    { valor: 'grande', label: 'Altura dupla' }
  ];

  opcoesLayoutDef: any[] = [
    { key: 'secEmpresa', label: 'Empresa', help: 'Nome/logo no topo' },
    { key: 'secCabecalhoPedido', label: 'Cabeçalho do pedido', help: 'Pedido/Comanda, código, mesa' },
    { key: 'secDataHorario', label: 'Data/Horário', help: 'Data do pedido/comanda e horário' },

    { key: 'secAgendamento', label: 'Agendamento', help: 'Entrega agendada' },
    { key: 'secRetirada', label: 'Retirada', help: 'Mensagem de retirada' },
    //{ key: 'secExterno', label: 'Pedido externo', help: 'iFood/Keeta etc' }, não deveria ser opcional

    { key: 'secDadosCliente', label: 'Dados do cliente', help: 'Bloco do cliente', permiteTamanhoTexto: false },
    { key: 'secNomeCliente', label: 'Nome do cliente', help: 'Nome/identificação' },
    { key: 'secTelefoneCliente', label: 'Telefone', help: 'Telefone (se não oculto)' },
    { key: 'secEnderecoEntrega', label: 'Endereço de entrega', help: 'Endereço completo' },
    { key: 'secHistoricoCliente', label: 'Histórico do cliente', help: 'Quantidade de pedidos' },

    { key: 'secItens', label: 'Itens', help: 'Lista de itens' },
    { key: 'secCabecalhoColunasItens', label: 'Cabeçalho colunas', help: 'Descrição/Qtde/Total' },
    { key: 'secTotalItem', label: 'Total por item', help: 'Coluna total (não resumido)', permiteTamanhoTexto: false },

    { key: 'secAdicionais', label: 'Adicionais', help: 'Adicionais do item' },
    { key: 'secObsItem', label: 'Obs do item', help: 'Observação por item' },

    { key: 'secPagamentos', label: 'Pagamentos', help: 'Seção de pagamentos' },
    { key: 'secObsPedido', label: 'Obs do pedido', help: 'Observações gerais' },
    { key: 'secPontos', label: 'Pontos', help: 'Fidelidade' },

    { key: 'secGarcom', label: 'Garçom', help: 'Nome do garçom' },

    { key: 'secAssinatura', label: 'Assinatura', help: 'Linha de assinatura' },
    { key: 'secOperador', label: 'Operador', help: 'Nome do operador' },
    { key: 'secImpressoEm', label: 'Impresso em', help: 'Data/hora impressão' },
    { key: 'secRodape', label: 'Rodapé', help: 'Texto final' }
  ];
  @Input()
  set empresa(empresa: any) {
    if(!empresa.configImpressao)
      empresa.configImpressao = {}

    if(!empresa.configImpressao.momentoImprimirAuto)
      empresa.configImpressao.momentoImprimirAuto =  EnumMomentoImprimirAuto.StatusPedido

    if(empresa.configImpressao.imprimirOnlineNaoPago === undefined)
      empresa.configImpressao.imprimirOnlineNaoPago = false

    // Garante que impressoras tenham setor preenchido
    if (empresa.configImpressao.impressoras) {
      empresa.configImpressao.impressoras.forEach(impressora => {
        if (!impressora.setor && impressora.nome) {
          impressora.setor = impressora.nome;
        }
      });
    }

    this._empresa = empresa;
  }

  get empresa() {
    return this._empresa;
  }

  // Propriedades para controle do servidor local
  isServidorLocal = false;
  servidorLocalConfigurado: any;

  constructor(
    private empresaService: EmpresasService,     private dialogService: DialogService,
    private impressao: ImpressaoService,
    private deviceService: DeviceDetectorService,
    private servidorImpressaoService: ServidorImpressaoService,
    private sanitizer: DomSanitizer
  ) {
    this.isMobile = this.deviceService.isMobile()
    if(this.isMobile) this.conectando = false;
  }

  async ngOnInit(): Promise<void> {
    // Força multiplasImpressoras sempre como true
    if (this.empresa?.configImpressao)
      this.empresa.configImpressao.multiplasImpressoras = true;

    // Carregar servidores de impressão
    await this.carregueServidoresImpressao();
    await this.verificarServidorLocal();
  }

  conectouQzTray(){
    this.qzInstalado = true;
    this.conectando = false;

    this.carregueImpressoras();
    this.carregueImpressorasDisponiveis()
  }

  private async verificarServidorLocal(): Promise<void> {
    try {
      // Verificar se este computador já está configurado como servidor
      this.servidorLocalConfigurado =  await this.servidorImpressaoService.getServidorRegistrado();

      if (this.servidorLocalConfigurado) {
        this.isServidorLocal = true;
        console.log('Este computador já está configurado como servidor de impressão');
      }
    } catch (erro) {
      console.error('Erro ao verificar servidor local:', erro);
    }
  }


  alterouTipoDeImpressao() {
    if(this.empresa.configImpressao.imprimirTXT) {
      if(!this.empresa.configImpressao.impressoras)
        this.empresa.configImpressao.impressoras = []

      if(!this.empresa.configImpressao.impressoras.find( impressora => !impressora.removida))
        this.empresa.configImpressao.impressoras.push({})

      this.carregueImpressoras()
    }
  }

  carregueImpressoras(){
    if(this.impressoras.length === 0){
      this.impressao.listeImpressoras().then((resultado: any) => {
        if(resultado.sucesso)
          this.impressoras = resultado.data;
        else
          this.erro = 'Houve um erro ao carregar a lista de impressoras: ' + resultado.erro;
      })
    }
  }

  carregueImpressorasDisponiveis() {
    let impressorasEmpresa: Array<any> = this.empresa.configImpressao.impressoras;

    this.impressorasDisponiveis = impressorasEmpresa.filter(
      (item: any) => !item.servidorImpressao);


    this.impressorasSelecionadas.forEach((impressora) => {
      this.impressorasDisponiveis.splice(0, 0, impressora)
    })

   /* if ( this.qzInstalado) {
      this.impressao.listeImpressoras().then((resultado: any) => {
        if (resultado.sucesso) {
          this.impressorasDisponiveis = resultado.data;
          // Filtrar impressoras que não estão vinculadas a outros servidores
          this.filtreImpressorasDisponiveis();
        } else {
          this.erro = 'Houve um erro ao carregar a lista de impressoras: ' + resultado.erro;
        }
      });
    } */
  }

  filtreImpressorasDisponiveis() {
    // Remover impressoras que já estão vinculadas a outros servidores
    this.impressorasDisponiveis = this.impressorasDisponiveis.filter(imp => {
      // Verificar se a impressora já está vinculada a outro servidor
      const servidorVinculado = this.servidoresImpressao.find(servidor =>
        servidor.impressoras && servidor.impressoras.find(impServidor =>
          impServidor.nome === imp && servidor.id !== this.servidorSelecionado?.id
        )
      );
      return !servidorVinculado;
    });
  }

  async obtenhaDetalhesImpressora(nomeImpressora: string): Promise<any> {
    if (this.detalhesImpressoras[nomeImpressora]) {
      return this.detalhesImpressoras[nomeImpressora];
    }

    try {
      this.carregandoDetalhes = true;

      // Usar QZ Tray para obter detalhes da impressora
      const detalhes = await this.impressao.obtenhaDetalhesImpressora(nomeImpressora);

      if (detalhes && detalhes.sucesso) {
        this.detalhesImpressoras[nomeImpressora] = detalhes.data;
        return detalhes.data;
      } else {
        // Fallback para informações básicas
        return {
          nome: nomeImpressora,
          status: 'Disponível',
          localizacao: 'Local',
          tipo: 'Impressora Local'
        };
      }
    } catch (erro) {
      console.error('Erro ao obter detalhes da impressora:', erro);
      return {
        nome: nomeImpressora,
        status: 'Erro ao obter detalhes',
        localizacao: 'Desconhecido',
        tipo: 'Impressora Local'
      };
    } finally {
      this.carregandoDetalhes = false;
    }
  }

  toggleImpressoraSelecionada(impressora: string) {
    const index = this.impressorasSelecionadas.indexOf(impressora);
    if (index > -1) {
      this.impressorasSelecionadas.splice(index, 1);
    } else {
      this.impressorasSelecionadas.push(impressora);
    }
  }

  impressoraEstaSelecionada(impressora: string): boolean {
    return this.impressorasSelecionadas.includes(impressora);
  }

  podeSalvarServidor(): boolean {
    if (this.modoCriacaoRapidaServidor) {
      return !!this.servidorSelecionado?.nome;
    }

    return this.servidorSelecionado?.nome &&
           this.impressorasSelecionadas.length > 0;
  }

  onSubmitConfigImpressao() {
    this.mensagemSucesso = '';
    delete this.erro;
    if( !this.frmConfigImpressao.valid || this.salvando)   return;

    this.salvando = true;
    this.empresaService.salveConfigImpressao(this.empresa).then( (configImpressao) => {
      this.empresa.configImpressao = configImpressao;
      this.impressorasAlteradas = false;
      if(!this.recarregar){
        this.salvando = false;
        this.mensagemSucesso = "As configurações de impressão foram atualizadas";
      } else {
        location.reload();
      }
    }).catch( (erro) => {
      this.salvando = false;
      this.erro = erro;
    });
  }

  adicionarNovaImpressa() {
    const novaImpressora = {
      novo: true,
      imprimirAutomatico: true, // valores padrão se desejar
      layout: this.layouts[0]
    };

    this.empresa.configImpressao.impressoras.push(novaImpressora);
    const index = this.empresa.configImpressao.impressoras.length - 1;

    // Abre o popup imediatamente
    this.abrirConfigImpressora(novaImpressora, index);
  }

  alterouLeiaute() {
    if(this.empresa.configImpressao.layoutPedido !== 'Ambos'){
      this.layouts = [this.empresa.configImpressao.layoutPedido]

      if(this.empresa.configImpressao.impressoras)
        this.empresa.configImpressao.impressoras.forEach( (impressora: any) => {
          if(impressora.layout !== this.empresa.configImpressao.layoutPedido )
            delete impressora.layout
        })
    } else {
      this.layouts  = ['PedidoCompleto', 'PedidoResumido', 'UmPorProduto'];
    }
  }

  excluirImpressora(impressora){
    if(impressora.id){
      impressora.removida = true;
    } else {
      this.empresa.configImpressao.impressoras.splice(  this.empresa.configImpressao.impressoras.indexOf(impressora), 1)
    }
    this.impressorasAlteradas = true;
  }

  marqueRecarregar() {
    this.recarregar = true;
  }

  abrirConfigImpressora(impressora: any, index: number) {
    this.impressoraSelecionada = {...impressora};
    // Garante que ao abrir o popup, o setor já esteja preenchido
    if (!this.impressoraSelecionada.setor && this.impressoraSelecionada.nome)
      this.impressoraSelecionada.setor = this.impressoraSelecionada.nome;


    this.indexSelecionado = index;
    // Preparar seleção atual de servidor
    if (this.impressoraSelecionada.servidorImpressao ) {
      this.impressoraSelecionada.imprimirApenasNesteComputador = true;
      this.impressoraSelecionada.servidorImpressao = this.servidoresImpressao.find(
        (item: any) => item.id === this.impressoraSelecionada.servidorImpressao.id )
    }

    this.atualizarPreviewImpressora();
  }

  fecharConfigImpressora() {
    // Se for uma nova impressora e não foi configurada, remove
    if (this.impressoraSelecionada?.novo && !this.impressoraSelecionada.nome) {
      const index = this.empresa.configImpressao.impressoras.findIndex(
        imp => imp === this.impressoraSelecionada
      );
      if (index > -1) {
        this.empresa.configImpressao.impressoras.splice(index, 1);
      }
    }

    this.impressoraSelecionada = null;
    this.indexSelecionado = -1;
    this.limparPreviewImpressora();
  }

  salvarConfigImpressora(frmImpressora: NgForm) {
    this.msgErro = null;

    if(!frmImpressora.valid){
       this.msgErro = 'verifique campos obrigatórios'
       return;
    }

    if (this.indexSelecionado >= 0) {
      delete this.impressoraSelecionada.novo;

      // Se não tiver setor, usa o nome da impressora
      if (!this.impressoraSelecionada.setor && this.impressoraSelecionada.nome) {
        this.impressoraSelecionada.setor = this.impressoraSelecionada.nome;
      }

      // Atualiza associação com servidor selecionado
      if (!this.impressoraSelecionada.imprimirApenasNesteComputador)
        delete this.impressoraSelecionada.servidorImpressao;

      this.empresa.configImpressao.impressoras[this.indexSelecionado] = {...this.impressoraSelecionada};
      this.impressorasAlteradas = true;
    }
    this.fecharConfigImpressora();
  }

  // Também podemos adicionar um watch na mudança do nome da impressora
  onImpressoraNomeChange() {
    if (!this.impressoraSelecionada.setor && this.impressoraSelecionada.nome) {
      this.impressoraSelecionada.setor = this.impressoraSelecionada.nome;
    }
  }


  // NOVOS MÉTODOS PARA SERVIDORES DE IMPRESSÃO

  async carregueServidoresImpressao(): Promise<void> {
    try {
      this.servidoresImpressao = await this.servidorImpressaoService.listeServidores();
      this.temServidorImpressao = this.servidoresImpressao.length > 0;
    } catch (erro) {
      console.error('Erro ao carregar servidores de impressão:', erro);
      this.erro = 'Erro ao carregar servidores de impressão';
    }
  }

  editarServidorDaImpressora(impressora: any){
    let servidor = this.servidoresImpressao.find((item: any) => item.id === impressora.servidorImpressao.id)

    this.editarServidor(servidor);
  }

  obtenhaStatusServidor(servidor: any): string {
    if (!servidor.ativo) return 'Inativo';

    // Verificar se está ativo baseado na última atividade
    const agora = new Date();
    const cincoMinutosAtras = new Date(agora.getTime() - 5 * 60 * 1000);

    if (servidor.ultimaAtividade && new Date(servidor.ultimaAtividade) > cincoMinutosAtras) {
      return 'Ativo';
    }

    return 'Inativo (Timeout)';
  }

  obtenhaStatusClass(servidor: any): string {
    if (!servidor.ativo) return 'status-inativo';

    const agora = new Date();
    const cincoMinutosAtras = new Date(agora.getTime() - 5 * 60 * 1000);

    if (servidor.ultimaAtividade && new Date(servidor.ultimaAtividade) > cincoMinutosAtras) {
      return 'status-ativo';
    }

    return 'status-timeout';
  }

  limparMensagens(): void {
    this.mensagemSucesso = '';
    this.erro = '';
  }

  // Checkbox: imprimir apenas nesse computador
  onToggleImprimirApenasNesteComputador(): void {
    if (!this.impressoraSelecionada.imprimirApenasNesteComputador) {

      delete this.impressoraSelecionada.servidorImpressao;
    }
  }

  novoServidorRapido(): void {
    this.modoCriacaoRapidaServidor = true;
    this.msgErro = null;

    if(this.isServidorLocal){
      let servidor = this.servidoresImpressao.find((item: any) => item.id === this.servidorLocalConfigurado.id)
      this.impressoraSelecionada.servidorImpressao = servidor;
    } else {
      this.abrirConfigServidorImpressao();
    }
  }

  editarServidor(servidor: any): void {
    this.servidorSelecionado = { ...servidor };
    this.editandoServidor = true;
    this.modalServidorAberto = true;

    this.servidorSelecionado.isServidorLocal = this.isServidorLocal

    setTimeout(() => {
      // this.modalServidorImpressao.setServidor()
    }, 0)

  }

  abrirConfigServidorImpressao(): void {
    this.modalServidorAberto = true;
    this.editandoServidor = false;
    this.servidorSelecionado = { computadorId: this.servidorImpressaoService.getIdentificacaoMaquina(), ativo: true};
    this.impressorasSelecionadas = [];
    this.detalhesImpressoras = {};
    this.carregueImpressorasDisponiveis();
  }


  salvouServidor(servidor: any){
    this.fecharModalServidor();

    if(servidor.id){
      this.servidoresImpressao.push(servidor)
      if(this.impressoraSelecionada)
        this.impressoraSelecionada.servidorImpressao = servidor;
    }
  }

  fechouModalServidor(result){
    this.fecharModalServidor();

    if(result && result.recarregar)
      this.carregueServidoresImpressao().then(() => { });
  }


  fecharModalServidor(): void {
    this.modalServidorAberto = false;
    this.editandoServidor = false;
    this.servidorSelecionado = null;
    this.configurandoLocal = false;
    this.impressorasSelecionadas = [];
    this.detalhesImpressoras = {};
    this.modoCriacaoRapidaServidor = false;
  }

  trackByOpcaoLayout(index: number, item: any){
    return item.key;
  }

  getDefaultOpcoesLayout(): any {
    const obj: any = { estilos: {} };
    this.opcoesLayoutDef.forEach(o => {
      obj[o.key] = true;
      obj.estilos[o.key] = this.getDefaultEstiloLayout();
    });
    return obj;
  }

  getDefaultEstiloLayout(): any {
    return { tamanhoFonte: 'normal' };
  }

  normalizeEstilosLayout(opcoesLayout: any): void {
    if(!opcoesLayout) return;

    if(!opcoesLayout.estilos){
      if(opcoesLayout.estilosJson){
        try {
          opcoesLayout.estilos = JSON.parse(opcoesLayout.estilosJson);
        } catch (erro) {
          opcoesLayout.estilos = {};
        }
      } else {
        opcoesLayout.estilos = {};
      }
    }

    this.opcoesLayoutDef.forEach(o => {
      if(!opcoesLayout.estilos[o.key])
        opcoesLayout.estilos[o.key] = this.getDefaultEstiloLayout();

      if(!opcoesLayout.estilos[o.key].tamanhoFonte)
        opcoesLayout.estilos[o.key].tamanhoFonte = 'normal';

      if(Object.prototype.hasOwnProperty.call(opcoesLayout.estilos[o.key], 'negrito'))
        delete opcoesLayout.estilos[o.key].negrito;
    });
  }

  ensureOpcoesLayoutImpressora(): void {
    if(!this.impressoraSelecionada) return;

    if(!this.impressoraSelecionada.opcoesLayout)
      this.impressoraSelecionada.opcoesLayout = this.getDefaultOpcoesLayout();

    this.opcoesLayoutDef.forEach(o => {
      const k = o.key;
      if(this.impressoraSelecionada.opcoesLayout[k] === undefined || this.impressoraSelecionada.opcoesLayout[k] === null)
        this.impressoraSelecionada.opcoesLayout[k] = true;
    });

    this.normalizeEstilosLayout(this.impressoraSelecionada.opcoesLayout);
  }

  abrirDialogLayoutPersonalizado(): void {
    this.previewCarregando = false;
    this.opcoesLayoutTempAlterado = false;

    this.ensureOpcoesLayoutImpressora();

    // clone simples
    this.opcoesLayoutTemp = {
      ...this.impressoraSelecionada.opcoesLayout,
      estilos: JSON.parse(JSON.stringify(this.impressoraSelecionada.opcoesLayout.estilos || {}))
    };
    this.normalizeEstilosLayout(this.opcoesLayoutTemp);

    this.dialogLayoutAberto = true;

    setTimeout(() => {
      this.atualizarPreviewLayoutTemp();
    }, 0);
  }

  fecharDialogLayoutPersonalizado(aplicar: boolean): void {
    if(aplicar && this.opcoesLayoutTemp){
      this.impressoraSelecionada.opcoesLayout = { ...this.opcoesLayoutTemp };
      this.atualizarPreviewImpressora();
    }

    this.dialogLayoutAberto = false;
    this.opcoesLayoutTemp = null;
    this.opcoesLayoutTempAlterado = false;
    this.previewCarregando = false;
    // opcional: manter preview ou limpar
    // this.previewHtml = null;
  }

  alterouOpcoesLayoutTemp() {
    this.opcoesLayoutTempAlterado = true;
    this.atualizarPreviewLayoutTemp();
    this.previewCarregando = true;
  }

  atualizarPreviewLayoutTemp() {
    if(this.isPreviewModoTexto()){
      const impressoraPreview = {
        ...this.impressoraSelecionada,
        layout: 'Personalizado',
        modoHTML: false,
        opcoesLayout: this.opcoesLayoutTemp
      };
      const processador = new ProcessadorReciboTexto(impressoraPreview);

      this.previewTextoSecoes = processador.obtenhaSecoesReciboPersonalizado(this.criePedidoPreviewTexto());
      this.previewUrl = null;
      this.previewUrlSafe = null;
      this.previewCarregando = false;
      return;
    }

    this.previewTextoSecoes = [];

    const url = this.impressao.getPreviewLayoutUrl({
      idImpressora: this.impressoraSelecionada?.id,
      opcoesLayout: this.opcoesLayoutTemp,
      resumido: false
    });

    this.previewUrl = url;
    this.previewUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  isPreviewModoTexto(): boolean {
    return this.impressoraSelecionada?.layout === 'Personalizado'
      && this.empresa?.configImpressao?.imprimirTXT
      && !this.empresa?.configImpressao?.modoHTML;
  }

  getTamanhosFonteLayout(): any[] {
    return this.isPreviewModoTexto() ? this.tamanhosFonteLayoutTexto : this.tamanhosFonteLayoutHtml;
  }

  getLabelFonteLayout(): string {
    return this.isPreviewModoTexto() ? 'Modo ESC/POS' : 'Tamanho';
  }

  getPreviewTextoColunas(): number {
    const tp = this.impressoraSelecionada?.tamanhoPapel;
    if(tp === EnumTamanhoPapel.Layout58mm32car) return 31;
    if(tp === EnumTamanhoPapel.Layout58mm) return 35;
    if(tp === EnumTamanhoPapel.Layout80mm42car) return 42;
    return 48;
  }

  getLabelTamanhoPapel(tamanhoPapel: string): string {
    const item = this.listaTamanhosPapeis.find(papel => papel.valor === tamanhoPapel);
    return item ? item.label : (tamanhoPapel || 'Papel padrão');
  }

  getLabelLayout(layout: string): string {
    switch(layout) {
      case 'PedidoCompleto':
        return 'Pedido completo';
      case 'PedidoResumido':
        return 'Pedido resumido';
      case 'UmPorProduto':
        return 'Um papel por produto';
      case 'Personalizado':
        return 'Personalizado';
      default:
        return layout || 'Layout padrão';
    }
  }

  atualizarPreviewImpressora(): void {
    if(!this.impressoraSelecionada){
      this.limparPreviewImpressora();
      return;
    }

    const impressoraPreview = this.crieImpressoraPreview();
    this.previewImpressoraCarregando = true;

    if(this.deveUsarPreviewTextoImpressora(impressoraPreview)){
      const processador = new ProcessadorReciboTexto({
        ...impressoraPreview,
        modoHTML: false
      });
      const pedidoPreview = this.criePedidoPreviewTexto();

      if(impressoraPreview.layout === 'Personalizado') {
        this.previewImpressoraTextoSecoes = processador.obtenhaSecoesReciboPersonalizado(pedidoPreview);
      } else {
        const paginas = processador.obtenhaRecibo(pedidoPreview, impressoraPreview.layout)
          .split(ProcessadorReciboTexto._MARCADOR_FIM_PAPEL)
          .filter(pagina => !!pagina);

        this.previewImpressoraTextoSecoes = [{
          secao: impressoraPreview.layout,
          texto: paginas.join('\n\n--- proximo papel ---\n\n'),
          tamanhoFonte: 'normal'
        }];
      }

      this.previewImpressoraUrl = null;
      this.previewImpressoraUrlSafe = null;
      this.previewImpressoraCarregando = false;
      return;
    }

    this.previewImpressoraTextoSecoes = [];

    const url = this.impressao.getPreviewLayoutUrl({
      impressora: impressoraPreview,
      resumido: impressoraPreview.layout === 'PedidoResumido',
      opcoesLayout: impressoraPreview.layout === 'Personalizado' ? impressoraPreview.opcoesLayout : null
    });

    this.previewImpressoraUrl = url;
    this.previewImpressoraUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    if(impressoraPreview.tamanhoPapel === EnumTamanhoPapel.LayoutA4)
      this.previewImpressoraCarregando = false;
  }

  isPreviewImpressoraModoTexto(): boolean {
    return this.previewImpressoraTextoSecoes.length > 0;
  }

  isPapelA4Selecionado(): boolean {
    return this.impressoraSelecionada?.tamanhoPapel === EnumTamanhoPapel.LayoutA4;
  }

  abrirPreviewImpressoraNovaAba(): void {
    if(!this.previewImpressoraUrl)
      return;

    window.open(this.previewImpressoraUrl, '_blank');
  }

  private limparPreviewImpressora(): void {
    this.previewImpressoraCarregando = false;
    this.previewImpressoraUrl = null;
    this.previewImpressoraUrlSafe = null;
    this.previewImpressoraTextoSecoes = [];
  }

  private crieImpressoraPreview(): any {
    const impressoraPreview: any = {
      ...this.impressoraSelecionada,
      layout: this.obtenhaLayoutPreviewImpressora(),
      tamanhoPapel: this.impressoraSelecionada?.tamanhoPapel || EnumTamanhoPapel.Layout80mm,
      modoHTML: !!this.empresa?.configImpressao?.modoHTML
    };
    delete impressoraPreview.servidorImpressao;
    delete impressoraPreview.produtos;

    if(impressoraPreview.opcoesLayout)
      impressoraPreview.opcoesLayout = JSON.parse(JSON.stringify(impressoraPreview.opcoesLayout));

    if(impressoraPreview.layout === 'Personalizado') {
      if(!impressoraPreview.opcoesLayout)
        impressoraPreview.opcoesLayout = this.getDefaultOpcoesLayout();

      this.normalizeEstilosLayout(impressoraPreview.opcoesLayout);
    } else {
      delete impressoraPreview.opcoesLayout;
    }

    return impressoraPreview;
  }

  private obtenhaLayoutPreviewImpressora(): string {
    if(this.impressoraSelecionada?.layout)
      return this.impressoraSelecionada.layout;

    if(this.empresa?.configImpressao?.layoutPedido && this.empresa.configImpressao.layoutPedido !== 'Ambos')
      return this.empresa.configImpressao.layoutPedido;

    return 'PedidoCompleto';
  }

  private deveUsarPreviewTextoImpressora(impressoraPreview: any): boolean {
    if(impressoraPreview?.tamanhoPapel === EnumTamanhoPapel.LayoutA4)
      return false;

    if(impressoraPreview?.layout === 'UmPorProduto')
      return true;

    return !!this.empresa?.configImpressao?.imprimirTXT
      && !this.empresa?.configImpressao?.modoHTML;
  }

  private criePedidoPreviewTexto(): any {
    const agora = new Date();
    const itens: any[] = [
      {
        descricao: 'X-Burger Bacon (Pao brioche)',
        descricaoQtde: '1un',
        qtde: 1,
        valor: 28.90,
        total: 28.90,
        observacao: 'Sem cebola',
        adicionaisImprirmir: [
          { descricao: 'Bacon extra', preco: 3.00, qtde: 1 },
          { descricao: 'Cheddar', preco: 2.50, qtde: 1 }
        ]
      },
      {
        descricao: 'Coca-Cola Lata 350ml',
        descricaoQtde: '2un',
        qtde: 2,
        valor: 6.00,
        total: 12.00,
        observacao: null,
        adicionaisImprirmir: []
      }
    ];

    const subvalor = itens.reduce((total, item) => total + item.total, 0);
    const taxaEntrega = 5;
    const total = subvalor + taxaEntrega;

    return {
      id: 999999,
      codigo: 'PREVIEW-001',
      empresa: {
        nome: this.empresa?.nome || 'Empresa Exemplo',
        identificadorMesa: this.empresa?.identificadorMesa || 'Mesa'
      },
      ehComanda: false,
      mesa: null,
      horarioDescricao: agora.toLocaleString('pt-BR'),
      agoraDescricao: agora.toLocaleString('pt-BR'),
      retirar: false,
      formaDeEntrega: true,
      mensagemRetirada: 'Retirar no balcao',
      horarioEntregaAgendada: false,
      cliente: {
        id: 123,
        nome: 'Cliente Exemplo',
        telefone: '62999999999',
        telefoneFormatado: '(62) 99999-9999',
        qtdePedidos: 7
      },
      enderecoCompleto: 'Rua Exemplo, 123 - Centro - Goiania/GO',
      itens,
      pagamentos: [
        {
          valor: total,
          descricao: 'Dinheiro',
          trocoPara: 50,
          valorTroco: 50 - total,
          levarTroco: true
        }
      ],
      subvalor,
      taxaEntrega,
      descontoTaxaEntrega: 0,
      desconto: 0,
      taxaFormaDePagamento: 0,
      descontoFormaDePagamento: 0,
      cashback: 0,
      total,
      totalPagar: total,
      agruparAdicionais: false,
      observacoes: 'Entregar na portaria.',
      pontosGanhos: 10,
      pontosGanhosDescricao: '10 pontos',
      garcom: null,
      operador: { nome: 'Operador Exemplo' },
      acumulo: null,
      foiPagoOnline: false,
      pago: false,
      ocultarCobranca: false,
      cobrarTaxaServico: false
    };
  }

  marcarTodosOpcoesLayoutTemp(valor: boolean){
    if(!this.opcoesLayoutTemp)
      this.opcoesLayoutTemp = this.getDefaultOpcoesLayout();

    this.opcoesLayoutDef.forEach(o => this.opcoesLayoutTemp[o.key] = valor);
    this.alterouOpcoesLayoutTemp();
  }

  getPreviewPaperWidth(): string {
    if(!this.impressoraSelecionada) return '75mm';

    const tp = this.impressoraSelecionada.tamanhoPapel;
    if(tp === EnumTamanhoPapel.Layout58mm || tp === EnumTamanhoPapel.Layout58mm32car) return '53mm'; // seu CSS
    return '75mm';
  }


  alterouLayoutImpressora(){
    if(this.impressoraSelecionada?.layout === 'Personalizado')
      this.ensureOpcoesLayoutImpressora();

    this.atualizarPreviewImpressora();
  }

  alterouPapelImpressora(){
    if(this.dialogLayoutAberto)
      this.atualizarPreviewLayoutTemp();

    this.atualizarPreviewImpressora();
  }

  onIframeLoad() {
    this.previewCarregando = false;
  }

  onIframeImpressoraLoad() {
    this.previewImpressoraCarregando = false;
  }
}
